import React, { useContext, useEffect, useState } from "react";
import { BottomNavigation } from "reactjs-bottom-navigation";
// import { filterDataContext } from "../../App";
import "./style.css";
import { useSearchParams } from "react-router-dom";
import { filterDataContext } from "../../../App";
import {
  CallIcon,
  FootballIcon,
  MoreIcon,
  MotorSportIcon,
  RugbyIcon,
  TennisIcon,
} from "../../GlobalIcons";
import { SportTypeToShow, scrollToTop } from "../../../utils/func";

const Tabination = () => {
  const {
    sportsList,
    setMaxPriceInput,
    setMinPriceInput,
    setTicketAvailabiltyInput,
    setFilterSearchInput,
  } = useContext(filterDataContext);
  const [sportsListLength, setSportsLength] = useState(0);
  const [showMoreSports, setShowMoreSports] = useState(false);
  const [sportsData, setSportsData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (sportsList) {
      if (sportsList.length > 0) {
        const filteredSports = sportsList.filter(
          (sport) => sport.sport_id !== "formula1"
        );
        if (filteredSports) {
          setSportsLength(filteredSports.length);
          let sports = filteredSports.slice(0, 4).map((item, index) => ({
            title: SportTypeToShow(item.sport_id),
            icon: getSportIcon(item.sport_id),
            onClick: () => handleSportClick(item.sport_id),
          }));
          setSportsData(sports);
        }
      }
      setShowMoreSports(false);
    }
  }, [sportsList]);

  function getSportIcon(sportId) {
    switch (sportId) {
      case "soccer":
        return <FootballIcon />;
      case "motorsport":
        return (
          <span>
            <MotorSportIcon />
          </span>
        );
      case "tennis":
        return (
          <span>
            <TennisIcon />
          </span>
        );
      case "rugby":
        return (
          <span>
            <RugbyIcon />
          </span>
        );
      case "boxing":
        return (
          <span>
            <MoreIcon />
          </span>
        );
      default:
        return null;
    }
  }

  const handleResetFilters = () => {
    setSearchParams({ sport_type: searchParams.get("sport_type") });
    setMaxPriceInput("");
    setMinPriceInput("");
    setTicketAvailabiltyInput("");
    setFilterSearchInput("");
  };
  const handleSportClick = (sport_id) => {
    scrollToTop();
    handleResetFilters();
    setSearchParams({
      sport_type: sport_id === "soccer" ? "football" : sport_id,
    });
  };

  const getActiveTab = () => {
    let filteredTab = sportsList?.findIndex(
      (item) =>
        item.sport_id ==
        (searchParams.get("sport_type") == "football"
          ? "soccer"
          : searchParams.get("sport_type"))
    );
    return filteredTab;
  };

  return (
    <div className="bottom_naviagte">
      <BottomNavigation
        items={
          sportsListLength > 4
            ? [
                ...sportsData,
                {
                  icon: (
                    <div>
                      <MoreIcon />
                      {showMoreSports === true && (
                        <div
                          className="view-more-dropdown"
                          style={{ position: "absolute" }}
                        >
                          {sportsList
                            ?.filter((sport) => sport.sport_id !== "formula1")
                            .slice(4, sportsListLength)
                            .map((item) => (
                              <div
                                key={item.sport_id}
                                style={{ color: "black" }}
                                onClick={() => {
                                  handleSportClick(item.sport_id);
                                  setShowMoreSports(!showMoreSports);
                                }}
                              >
                                {item.sport_id}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  ),
                  title: "View More",
                  onClick: () => {
                    setShowMoreSports(!showMoreSports);
                  },
                },
              ]
            : sportsData
        }
        selected={() => getActiveTab()}
        activeBgColor="slateBlue"
        activeTextColor="white"
      />
    </div>
  );
};

export default Tabination;
